/**
 * Created by mac on 12/15/20
 */

const FogBlockView = cc.Node.extend({ 
    ctor: function (fogBlock) {
        this._super();
        this.fogBlock = fogBlock;

        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabled(true);

        this.setAnchorPoint(0.5, 0.5);

        fogBlock.onGetView = this.createListener(() => this);

        fogBlock.on("open", this.createListener(this.onOpen.bind(this)), this);
        fogBlock.on("updateState", this.createListener(this.onUpdateState.bind(this)), this);
        fogBlock.on("updateBlocker", this.createListener(this.onUpdateBlocker.bind(this)), this);
        fogBlock.on("wandsChanged", this.createListener(this.onWandsChanged.bind(this)), this);
        fogBlock.on("hintTapBlocker", this.createListener(this.hintTapBlocker.bind(this)), this);
    },

    hideBlocker: function () {
        if (this.blocker) {
            cleverapps.effects.fire("fog.unlock");

            this.blocker.blockers.forEach((blocker) => {
                blocker.openAnimation(this);
            });
            this.blocker.removeFromParent();
            this.blocker = undefined;
        }
    },

    createBlocker: function (conditions, silent) {
        const styles = cleverapps.skins.getSlot("fogBlocker") || cleverapps.styles.FogBlockView.blocker;
        const blockers = [];

        for (let i = 0; i < conditions.length; i++) {
            if (conditions[i].hidden) {
                continue;
            }
            const blocker = new FogLockView(conditions[i]);

            blockers.push(blocker);

            cleverapps.UI.onClick(blocker, this.fogBlock.displayCondition.bind(this.fogBlock, conditions[i]), {
                filter: function () {
                    if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive()) {
                        return Map2dLocation.currentLocation.tutorial.checkConditions({ fog: this.fogBlock.id });
                    }
                    if (cleverapps.tutorial.isActive()) {
                        return cleverapps.tutorial.checkConditions({ fog: this.fogBlock.id });
                    }
                    return true;
                }.bind(this)
            });
        }

        if (this.blocker) {
            this.blocker.removeFromParent();
        }

        this.blocker = new cleverapps.Layout(blockers, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        this.blocker.blockers = blockers;

        this.blocker.setCascadeColorEnabled(true);
        this.blocker.setCascadeOpacityEnabled(true);

        this.addChild(this.blocker);
        this.blocker.setAlignment(styles.position);
        this.blocker.setAnchorPoint(0.5, 0);
        if (!silent) {
            this.blocker.setScale(0);
            this.blocker.runAction(new cc.ScaleTo(0.3, 1));
            cleverapps.effects.fire("fog.lock");
        }
    },

    addBlocker: function (state, silent) {
        if (cleverapps.gameModes.fogBlockerDisabled) {
            return;
        }

        const conditions = this.fogBlock.blockerConditions || [];

        if (this.blocker && this.blocker.blockers) {
            for (let i = 0; i < this.blocker.blockers.length; i++) {
                let conditionRemoved = true;
                for (let j = 0; j < conditions.length; j++) {
                    if (this.blocker.blockers[i].checkCondition(conditions[j])) {
                        conditionRemoved = false;
                        break;
                    }
                }
                if (conditionRemoved) {
                    this.blocker.blockers[i].openAnimation(this);
                }
            }
        }

        if (state === FogBlock.NOTREADY) {
            this.createBlocker(conditions, silent);
        } else {
            this.hideBlocker();
        }
    },

    hintTapBlocker: function () {
        if (this.blocker) {
            Map2d.currentMap.focusOnTarget(this.blocker, {
                allowScrollWithFocus: true,
                skipFocusReport: true,
                callback: () => {
                    FingerView.hintTap(this.blocker, {
                        delay: 0.5,
                        runOnce: true
                    });
                }
            });
        }
    },

    createBar: function () {
        const styles = cleverapps.styles.FogBlockView.opener;

        const text = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.WAND_PROGRESS_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        text.setLocalZOrder(1);

        const bar = new ScaledProgressBar({
            background: bundles.progress_bar.frames.bg_fog,
            progress: bundles.progress_bar.frames.bar_fog_blue,
            progressFrames: {
                0: bundles.progress_bar.frames.bar_fog_blue,
                100: bundles.progress_bar.frames.bar_fog_green || bundles.progress_bar.frames.bar_fog_blue
            },

            onChange: function (silent) {
                const needed = this.fogBlock.getOpenPrice();
                const amount = Math.min(Map2dLocation.currentLocation.wands, needed);

                text.setString(`${amount} / ${needed}`);
                text.fitTo(styles.text.width);

                text.stopAllActions();
                if (silent) {
                    text.setScale(1);
                } else {
                    text.runAction(new cc.Sequence(
                        new cc.ScaleTo(0.15, 1.4),
                        new cc.ScaleTo(0.15, 1)
                    ));
                }
            }.bind(this)
        });
        bar.setLength(styles.width);
        bar.setAlignment(styles);

        const icon = this.icon = new cc.Sprite(bundles.reward_icons_merge.frames.wand_icon);
        icon.setAlignment(cleverapps.skins.getSlot("fogBlockWandPosition") || styles.icon);
        icon.setLocalZOrder(1);
        bar.addChild(icon);

        bar.addChild(text);

        return bar;
    },

    createOpenerWindow: function () {
        const styles = cleverapps.styles.FogBlockView.openerWindow;

        const container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setAlignment(styles);

        container.setAlignment(cleverapps.styles.FogBlockView.opener);
        container.setContentSize2(cleverapps.styles.FogBlockView.opener);

        if (!this.fogBlock.isFree()) {
            const opener = this.createBar();
            opener.setAlignment({ align: "center" }, { align: "center" });
            opener.setPercentage(100);
            container.addChild(opener);

            const blick = new cleverapps.Spine(bundles.fog.jsons.fog_progress_blick);
            blick.setAlignment(cleverapps.styles.FogBlockView.opener.blick);
            blick.setAnimation(0, "animation", false);
            blick.setCompleteListener(() => {
                setTimeout(blick.setAnimation.bind(blick, 0, "animation", false), PseudoRandom.GET().random(500, 1000));
            });
            opener.addChild(blick);
        }

        const openButton = container.button = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("FogBlock.attack"),
            textVariant: "tiny",
            onClicked: this.handleOpen.bind(this),
            type: styles.button.type || cleverapps.styles.UI.Button.Images.small_button_blue
        });
        openButton.adviceTarget = "openfog";
        openButton.setAlignment(this.fogBlock.isFree() ? styles.button.free : styles.button);
        container.addChild(openButton);

        return container;
    },

    hideOpener: function () {
        if (this.bar) {
            this.bar.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, 0),
                new cc.RemoveSelf()
            ));
            this.bar = undefined;
        }
    },

    hideOpenerWindow: function (delay) {
        if (!this.openerWindow) {
            return 0;
        }

        this.openerWindow.runAction(new cc.Sequence(
            new cc.DelayTime(delay || 0),
            new cc.ScaleTo(0.2, 0),
            new cc.RemoveSelf()
        ));
        this.openerWindow = undefined;
    },

    collectBubbles: function () {
        let delay = 0;

        if (!this.bubbles || !this.bubbles.length) {
            return delay;
        }

        delay = 0.5;

        this.bubbles.forEach((bubbleView) => {
            delay += 0.02;

            bubbleView.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                StandartAnimations.animateCollect(bubbleView, "mainWorld", {
                    collectEffect: true,
                    effect: "ui.jump.collect"
                }),
                new cc.CallFunc(() => {
                    cleverapps.toolbar.resetByType(ToolbarItem.TRAVEL_BOOK);
                }),
                new cc.RemoveSelf()
            ));
        });
        this.bubbles = undefined;

        return delay;
    },

    onWandsChanged: function (silent) {
        if (this.bar && !this.fogBlock.isMoney()) {
            const wands = this.fogBlock.fogs.wands;
            const needed = this.fogBlock.getOpenPrice();
            const amount = Math.min(wands, needed);

            this.bar.setGoal(needed, silent);
            this.bar.setPercentage(amount, {
                time: 0,
                animated: !silent
            });
        }
    },

    addMoneyOpennerWindow: function (silent) {
        const styles = cleverapps.styles.FogBlockView.openerWindow.money;

        this.openerWindow = new cc.Node();
        this.openerWindow.setAnchorPoint(0.5, 0.5);
        this.openerWindow.setAlignment(styles);
        this.addChild(this.openerWindow);

        const sellerIcon = new cc.Sprite(bundles.merge.frames.seller_icon);
        sellerIcon.setAlignment(styles.sellerIcon);
        sellerIcon.fogBlockId = this.fogBlock.id;

        const filter = function () {
            if (!this.fogBlock || !this.fogBlock.id) {
                return false;
            }
            if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive()) {
                return Map2dLocation.currentLocation.tutorial.checkConditions({ fog: this.fogBlock.id });
            }
            if (cleverapps.tutorial.isActive()) {
                return cleverapps.tutorial.checkConditions({ fog: this.fogBlock.id });
            }
            return true;
        }.bind(this);

        cleverapps.UI.onClick(sellerIcon, this.handleBuy.bind(this), {
            filter
        });
        cleverapps.UI.applyHover(sellerIcon, {
            filter
        });
        this.openerWindow.addChild(sellerIcon);

        const parsed = RewardTypes.units.parse(this.fogBlock.getBubbles(), { toMainWorld: true });

        const bubbles = this.bubbles = parsed.filter((reward) => reward.type === "units").map(function (reward) {
            const bubbleView = new PocketBubbleView(reward.value);
            cleverapps.UI.onClick(bubbleView, this.fogBlock.showBuyWindow.bind(this.fogBlock), {
                filter
            });
            return bubbleView;
        }, this);

        const bubblesLayout = new cleverapps.Layout(bubbles, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.bubbles.margin
        });
        bubblesLayout.setAlignment(styles.bubbles);
        this.openerWindow.addChild(bubblesLayout);

        if (!silent) {
            this.openerWindow.setScale(0);
            this.openerWindow.runAction(new cc.ScaleTo(0.3, 1));
        }
    },

    handleBuy: function () {
        this.fogBlock.showBuyWindow();
    },

    addOpenner: function (state, silent) {
        if (state === FogBlock.CANTOPEN) {
            if (!this.bar) {
                this.bar = this.createBar();
                this.addChild(this.bar);
                this.onWandsChanged(silent);

                if (!this.fogBlock.isMoney() && !this.fogBlock.isSpecial()) {
                    const hasOtherTarget = cleverapps.aims.getTarget("map2dWands", { noDefault: true });
                    cleverapps.aims.registerTarget("map2dWands", this.icon, {
                        priority: 1 / (this.fogBlock.getOpenPrice() + hasOtherTarget ? 1 : 0),
                        filter: function () {
                            return this.fogBlock;
                        }.bind(this),
                        scrollsToTarget: function () {
                            if (Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive()) {
                                return false;
                            }

                            return this.fogBlock && this.fogBlock.getOpenPrice() <= Map2dLocation.currentLocation.wands;
                        }.bind(this),
                        animate: this.animateIcon.bind(this)
                    });
                }

                if (!silent) {
                    this.bar.setScale(0);
                    this.bar.runAction(new cc.ScaleTo(0.3, 1));
                }
            }
        } else {
            this.hideOpener();
        }
    },

    animateIcon: function () {
        if (this.icon) {
            this.icon.stopAllActions();
            this.icon.setScale(1);
            this.icon.runAction(
                new cc.Sequence(
                    new cc.ScaleTo(0.05, 1.2).easing(cc.easeIn(1)),
                    new cc.ScaleTo(0.05, 1).easing(cc.easeOut(1))
                )
            );
        }
    },

    addOpennerWindow: function (state, silent) {
        if (state === FogBlock.CANOPEN) {
            if (this.fogBlock.isMoney()) {
                this.addMoneyOpennerWindow(silent);
                return;
            }

            this.openerWindow = this.createOpenerWindow();
            this.addChild(this.openerWindow);

            if (!silent) {
                this.openerWindow.setScale(0);
                this.openerWindow.runAction(new cc.ScaleTo(0.3, 1));
            }

            if (!silent || !FingerView.currentFinger) {
                this.updatePromptFinger();
            }
        } else {
            this.hideOpenerWindow();
        }
    },

    removeBalloons: function () {
        const balloons = this.balloons;
        const balloonsAnimation = this.balloonsAnimation;

        if (balloons) {
            delete this.balloons;
            delete this.balloonsAnimation;

            balloonsAnimation.setAnimation(0, "close", false);
            balloonsAnimation.setCompleteListener(() => {
                balloonsAnimation.setCompleteListener(null);
                balloons.removeFromParent();
            });

            if (balloons.hoverHandler) {
                balloons.hoverHandler.remove();
                balloons.hoverHandler = undefined;
            }

            cleverapps.pointerManager.removeAll(balloons);
        }
    },

    updatePromptFinger: function () {
        if (!this.openerWindow || this.openerWindow.button.finger) {
            return;
        }

        if (Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() || this.fogBlock !== this.fogBlock.fogs.findAvailableFogBlock()) {
            return;
        }

        this.openerWindow.button.finger = FingerView.hintTap(this.openerWindow.button, {
            delay: 0.8,
            runOnce: true
        });
    },

    onUpdateState: function (state, silent) {
        if (!this.fogBlock.isFree()) {
            this.addOpenner(state, silent);
        }

        if (silent || !this.fogBlock.isFree()) {
            this.addOpennerWindow(state, silent);
        }
    },

    onUpdateBlocker: function (state, silent) {
        this.addBlocker(state, silent);
    },

    handleOpen: function () {
        if (this.fogBlock) {
            this.fogBlock.unlock();
        }
    },

    onOpen: function () {
        this.fogBlock = undefined;

        const delay = this.collectBubbles();

        this.hideBlocker();
        this.hideOpener();
        this.hideOpenerWindow(delay);
        this.removeBalloons();

        this.stopAllActions();
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.3 + delay),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    FOG_BLOCKER_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    WAND_PROGRESS_TEXT: {
        name: "default",
        size: 40
    }
});

cleverapps.styles.FogBlockView = {
    openerWindow: {
        x: { align: "center" },
        y: { align: "top", dy: 70 },

        button: {
            x: { align: "center" },
            y: { align: "bottom", dy: -80 },
            free: {
                x: { align: "center" },
                y: { align: "bottom" }
            },
            width: 240,
            height: 70
        },

        money: {
            x: { align: "center" },
            y: { align: "top", dy: 60 },

            sellerIcon: {
                x: { align: "center" },
                y: { align: "center" }
            },

            bubbles: {
                x: { align: "center" },
                y: { align: "center", dy: -100 },
                margin: 20
            }
        }
    },

    opener: {
        width: 280,
        height: 60,
        x: { align: "center" },
        y: { align: "top", dy: 70 },

        text: {
            width: 200,
            x: { align: "center", dx: 14 },
            y: { align: "center", dy: 2 }
        },
        icon: {
            x: { align: "left", dx: -4 },
            y: { align: "center", dy: 10 }
        },
        blick: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 2 }
        }
    },

    blocker: {
        position: {
            x: { align: "center" },
            y: { align: "center", dy: 50 }
        }
    }
};
